import React from "react";
import Image, { type StaticImageData } from "next/image";
import { Box, Flex, Text } from "@chakra-ui/react";

type TestimonialProps = {
  author: string;
  job: string;
  company?: string;
  image?: StaticImageData | string;
  quote: string;
};

export function MdxTestimonial({ author, quote, job, company, image }: TestimonialProps) {
  return (
    <Flex
      bg="new.blue.900"
      borderRadius="base"
      color="brand.text.dark"
      flexDir="column"
      gap="big"
      justifyContent="start"
      p={{ base: "big", md: "bigger" }}
    >
      <Text textStyle={{ base: "body2", md: "body1" }} fontWeight="semibold" mt="smaller">
        “{quote}”
      </Text>

      <Flex align="center" gap="smallest">
        {image && (
          <Box
            flex="none"
            boxSize="50px"
            display="block"
            position="relative"
            bg="new.blue.50"
            borderRadius="full"
            overflow="hidden"
          >
            <Image fill sizes="100%" src={image} alt={author} style={{ objectFit: "cover" }} />
          </Box>
        )}

        <Box>
          <Text textStyle="caption1" fontWeight="semibold" mb="tiniest">
            {author}
          </Text>
          <Flex textStyle="caption1">
            <Text>{job}</Text>
            {company && <Text>, {company}</Text>}
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
}
